module.exports = __webpack_public_path__ + "img/coming-soon.4f15e7a3.png";